import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import HoverOver from '../HoverOver';

import UsaOutline from "../Map/UsaOutline";
import UsaStateHovers from "../Map/UsaStateHovers";
import UsaStateBorders from "../Map/UsaStateBorders";
import UsaStateLabels from "../Map/UsaStateLabels";
import NationalMapShapes from "./NationalMapShapes";

import '../Map/Map.css';
import './NationalMap.css';

class NationalMap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 250
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    const maxHeight = this.props.maxHeight || width;
    this.setState({width: width, height: Math.min(maxHeight, width * .64)});
  }

  render() {
    const self = this;

    return (
      <div ref="wrapper" className="NationalMap" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <UsaOutline width={this.state.width} height={this.state.height}/>
          <NationalMapShapes
            data={this.props.data}
            dict={this.props.dict}
            width={this.state.width}
            height={this.state.height}
            dimX={this.props.dimX}
            dimY={this.props.dimY}
            year={this.props.year}
            type={this.props.type}
          />
          <UsaStateBorders width={this.state.width} height={this.state.height}/>
          <UsaStateLabels width={this.state.width} height={this.state.height}/>
          <UsaStateHovers
            width={this.state.width}
            height={this.state.height}
            onHoverOver={(stateFips, coords) => {
              const hover = {
                data: _.get(self, ['props', 'dict', stateFips], null),
                props:self.props,
                coords,
              };

              self.setState({hover});
              d3.selectAll("#FIPS_" + stateFips).attr("class", "hover_over");
            }}
            onHoverOut={stateFips => {
              d3.selectAll("#FIPS_" + stateFips).attr("class", "hover_out");
              self.setState({hover: null})
            }}
            onClick={stateFips => {
              if (this.props.onClick) {
                this.props.onClick(stateFips)
              }
            }}/>
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

NationalMap.propTypes = {
  maxHeight: PropTypes.number,
  onClick: PropTypes.func,
  titleX: PropTypes.string,
  titleY: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  year: PropTypes.number,
  type: PropTypes.string,
  data: PropTypes.array,
  dict: PropTypes.object
};

export default NationalMap;


// WEBPACK FOOTER //
// ./src/charts/NationalMap/index.js